import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'hypenation-tickets-payment-method-selection',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './payment-method-selection.component.html',
  styleUrl: './payment-method-selection.component.css',
})
export class PaymentMethodSelectionComponent {
  // @Input() paymentMethods: PaymentMethod[] = [];
  // @Input() selectedPaymentMethod!: PaymentMethod;

  // @Output() paymentMethodChange = new EventEmitter<PaymentMethod>();

  // onTicketChange(paymentMethod: PaymentMethod) {
  //   this.selectedPaymentMethod = paymentMethod;
  //   this.paymentMethodChange.emit(paymentMethod);
  // }
}
